import { render, staticRenderFns } from "./ActivateCardForm.vue?vue&type=template&id=0da6a9ae&"
import script from "./ActivateCardForm.vue?vue&type=script&lang=js&"
export * from "./ActivateCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports